module.exports = __webpack_public_path__ + "static/img/Customised_Clothing_Headers-04.cdd6e56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/2024/Customised_Clothing_Headers-04.png
// module id = u9yu
// module chunks = 1